import snackBar from './snackBar';
export default {
    namespaced: true,
    state: {
    },
    mutations: {},
    actions: {},
    modules: {
        snackBar
    }
}